import { StyleSheet } from "react-native";
import { pageContainerStyle } from '../../common.style';

export default StyleSheet.create({
    container: {
        ...pageContainerStyle,
        backgroundColor: '#ffffff',
        paddingHorizontal: 16,
        paddingTop: 20,
        height: '100%',
    },
    pastille: {
        borderRadius: '100%',
        height: 40,
        width: 40,
        justifyContent: 'center',
        alignItems: 'center',
    },
    pastilleText: {
        fontSize: 20,
        fontWeight: 500
    },
    agentContent: {
        flexDirection: 'row',
        gap: 10,
        alignItems: 'center'
    },
    agentBubble: {
        width: 42,
        height: 42,
        borderRadius: 21,
        backgroundColor: '#6366F1',
        justifyContent: 'center',
        alignItems: 'center',
    },
    agentInitials: {
        color: '#fff',
        fontWeight: '700',
        fontSize: 15,
    },
})
